import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { Contract } from "src/app/models/Contract";
import { ExcelExportType } from "src/app/models/ExcelExport";
import { CompanyService } from "src/app/services/company.service";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";

import { AuthService } from "./../../services/auth.service";
import { ContractService } from "./../../services/contract.service";

@Component({
  selector: "app-contracts",
  templateUrl: "./contracts.component.html",
  styleUrls: ["./contracts.component.scss"],
  standalone: false,
})
export class ContractsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;

  dataSource = new MatTableDataSource<Contract>([]);
  subscription: Subscription;
  faSpinner = faSpinner;
  page: number = 1;
  pageSize: number = 10;
  ExcelExportType = ExcelExportType;

  columns = [
    {
      key: "contractReference",
      title: LocalizationConstants.CONTRACT_CONTRACT_REFERENCE,
    },
    { key: "poNumber", title: LocalizationConstants.CONTRACT_PO_NUMBER },
    { key: "type", title: LocalizationConstants.CONTRACT_TYPE },
    { key: "startDate", title: LocalizationConstants.CONTRACT_START_DATE },
    { key: "endDate", title: LocalizationConstants.CONTRACT_END_DATE },
    { key: "isActive", title: LocalizationConstants.CONTRACT_STATUS },
  ];

  columnKeys = this.columns.map((column) => column.key);

  constructor(
    public contractService: ContractService,
    private companyService: CompanyService,
    private globalOverlayService: GlobalOverlayService,
    private auth: AuthService,
  ) {}

  ngOnInit() {
    this.subscription = this.onCompanyChange();
    if (!this.companyService.selectedCompany?.name) return;
    this.getContracts();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getContracts() {
    this.globalOverlayService.show();
    this.contractService
      .getContracts(this.companyService.selectedCompany.name)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => {
        if (!response) return;
        this.dataSource.data = response;
      });
  }

  onCompanyChange() {
    return this.companyService.companyChange.subscribe((company) => {
      if (!company?.name) return;
      this.getContracts();
    });
  }

  get userVisible() {
    return this.auth.user?.isUserGroupProfile;
  }
}
